var map = {
	"./": 160,
	"./Biochemie": 347,
	"./Biochemie.jpg": 347,
	"./ESR": 348,
	"./ESR.png": 348,
	"./about": 349,
	"./about.jpg": 349,
	"./bg1": 350,
	"./bg1.jpg": 350,
	"./block_4": 351,
	"./block_4.png": 351,
	"./brain-landing": 352,
	"./brain-landing.png": 352,
	"./brain1new@2x": 353,
	"./brain1new@2x.png": 353,
	"./brain3new@2x": 354,
	"./brain3new@2x.png": 354,
	"./channels/cardiology": 162,
	"./channels/cardiology.jpg": 162,
	"./channels/dermatology": 163,
	"./channels/dermatology.jpg": 163,
	"./channels/gastroenterology": 164,
	"./channels/gastroenterology.jpg": 164,
	"./channels/gynecology": 165,
	"./channels/gynecology.jpg": 165,
	"./channels/neurology": 166,
	"./channels/neurology.jpg": 166,
	"./channels/neurosurgery": 167,
	"./channels/neurosurgery.jpg": 167,
	"./channels/ophthalmology": 168,
	"./channels/ophthalmology.jpg": 168,
	"./channels/surgery": 169,
	"./channels/surgery.jpg": 169,
	"./channels/traumatology": 171,
	"./channels/traumatology.jpg": 171,
	"./checkbox_pink": 355,
	"./checkbox_pink.png": 355,
	"./claim_box_1_image": 356,
	"./claim_box_1_image.png": 356,
	"./close": 357,
	"./close.png": 357,
	"./company-logos/bern-logo": 358,
	"./company-logos/bern-logo.jpg": 358,
	"./company-logos/company-logos-desktop": 359,
	"./company-logos/company-logos-desktop.jpg": 359,
	"./company-logos/company-logos-mobile": 360,
	"./company-logos/company-logos-mobile.jpg": 360,
	"./company-logos/escap-logo": 361,
	"./company-logos/escap-logo.jpg": 361,
	"./company-logos/insel-spital-logo": 362,
	"./company-logos/insel-spital-logo.jpg": 362,
	"./company-logos/schweizerische-gesellschaft-logo": 363,
	"./company-logos/schweizerische-gesellschaft-logo.jpg": 363,
	"./company-logos/sgdv-ssdv-logo": 364,
	"./company-logos/sgdv-ssdv-logo.jpg": 364,
	"./company-logos/swiss-lung-association-logo": 365,
	"./company-logos/swiss-lung-association-logo.jpg": 365,
	"./company-logos/universitaetsspital-basel-logo": 366,
	"./company-logos/universitaetsspital-basel-logo.jpg": 366,
	"./company-logos/verband-logo": 367,
	"./company-logos/verband-logo.jpg": 367,
	"./cookie": 368,
	"./cookie.jpg": 368,
	"./credit_points_certification_image": 369,
	"./credit_points_certification_image.jpg": 369,
	"./credit_points_ready_for_download": 370,
	"./credit_points_ready_for_download.jpg": 370,
	"./customized-targeting": 371,
	"./customized-targeting.png": 371,
	"./docflix-green": 372,
	"./docflix-green.png": 372,
	"./docflix-logo": 339,
	"./docflix-logo-dark": 373,
	"./docflix-logo-dark.png": 373,
	"./docflix-logo.png": 339,
	"./docflix-logo.svg": 512,
	"./docspin-logo": 374,
	"./docspin-logo-dark": 375,
	"./docspin-logo-dark.png": 375,
	"./docspin-logo.svg": 374,
	"./face": 376,
	"./face.jpg": 376,
	"./hero-pharma-and-med-tech": 377,
	"./hero-pharma-and-med-tech.png": 377,
	"./hospitals-hero-image": 378,
	"./hospitals-hero-image.png": 378,
	"./icons/Alarm, Clock, Time": 379,
	"./icons/Alarm, Clock, Time.svg": 379,
	"./icons/Favorite": 380,
	"./icons/Favorite.svg": 380,
	"./icons/Hand, Arm, Heart": 381,
	"./icons/Hand, Arm, Heart.svg": 381,
	"./icons/Send message, Send, Share.1": 382,
	"./icons/Send message, Send, Share.1.svg": 382,
	"./icons/User,Profile.12": 383,
	"./icons/User,Profile.12.svg": 383,
	"./icons/active-doctors": 384,
	"./icons/active-doctors-percent": 385,
	"./icons/active-doctors-percent.svg": 385,
	"./icons/active-doctors.svg": 384,
	"./icons/analytics": 386,
	"./icons/analytics.svg": 386,
	"./icons/calendar": 387,
	"./icons/calendar-dark-blue": 388,
	"./icons/calendar-dark-blue.svg": 388,
	"./icons/calendar-white": 389,
	"./icons/calendar-white.svg": 389,
	"./icons/calendar.svg": 387,
	"./icons/clock": 390,
	"./icons/clock-dark": 391,
	"./icons/clock-dark.svg": 391,
	"./icons/clock-light": 392,
	"./icons/clock-light.svg": 392,
	"./icons/clock-white": 393,
	"./icons/clock-white.svg": 393,
	"./icons/clock.svg": 390,
	"./icons/comment-plus": 394,
	"./icons/comment-plus-dark": 395,
	"./icons/comment-plus-dark.svg": 395,
	"./icons/comment-plus.svg": 394,
	"./icons/community": 396,
	"./icons/community.svg": 396,
	"./icons/content-dist": 397,
	"./icons/content-dist.svg": 397,
	"./icons/create-event": 398,
	"./icons/create-event.svg": 398,
	"./icons/credit_points": 399,
	"./icons/credit_points.svg": 399,
	"./icons/de": 400,
	"./icons/de.svg": 400,
	"./icons/docflix-logo-dark": 401,
	"./icons/docflix-logo-dark.svg": 401,
	"./icons/docspin-logo-icon-only": 402,
	"./icons/docspin-logo-icon-only.svg": 402,
	"./icons/docspin-logo-without-icon": 403,
	"./icons/docspin-logo-without-icon.svg": 403,
	"./icons/edit": 404,
	"./icons/edit.svg": 404,
	"./icons/en": 405,
	"./icons/en.svg": 405,
	"./icons/es": 406,
	"./icons/es.svg": 406,
	"./icons/event": 407,
	"./icons/event.svg": 407,
	"./icons/events-count": 408,
	"./icons/events-count.svg": 408,
	"./icons/favorite-dark": 409,
	"./icons/favorite-dark.svg": 409,
	"./icons/fr": 410,
	"./icons/fr.svg": 410,
	"./icons/group": 411,
	"./icons/group.svg": 411,
	"./icons/heartrate": 412,
	"./icons/heartrate.svg": 412,
	"./icons/hospital": 413,
	"./icons/hospital-white": 414,
	"./icons/hospital-white.svg": 414,
	"./icons/hospital.svg": 413,
	"./icons/info": 415,
	"./icons/info.svg": 415,
	"./icons/it": 416,
	"./icons/it.svg": 416,
	"./icons/language": 417,
	"./icons/language.svg": 417,
	"./icons/lightbulb": 418,
	"./icons/lightbulb-light": 419,
	"./icons/lightbulb-light.svg": 419,
	"./icons/lightbulb.svg": 418,
	"./icons/livestream": 420,
	"./icons/livestream.svg": 420,
	"./icons/logout": 421,
	"./icons/logout.svg": 421,
	"./icons/manage": 422,
	"./icons/manage.svg": 422,
	"./icons/medbriefcase": 423,
	"./icons/medbriefcase.svg": 423,
	"./icons/medupp-brain": 424,
	"./icons/medupp-brain-dark": 425,
	"./icons/medupp-brain-dark.svg": 425,
	"./icons/medupp-brain.svg": 424,
	"./icons/medupp-logo-icon-only": 426,
	"./icons/medupp-logo-icon-only-red": 427,
	"./icons/medupp-logo-icon-only-red.svg": 427,
	"./icons/medupp-logo-icon-only.svg": 426,
	"./icons/message-dark": 428,
	"./icons/message-dark.svg": 428,
	"./icons/message-light": 429,
	"./icons/message-light.svg": 429,
	"./icons/misc": 430,
	"./icons/misc.svg": 430,
	"./icons/my-events": 431,
	"./icons/my-events.svg": 431,
	"./icons/my_questions": 432,
	"./icons/my_questions.svg": 432,
	"./icons/notes": 433,
	"./icons/notes.svg": 433,
	"./icons/plus-rounded": 434,
	"./icons/plus-rounded.svg": 434,
	"./icons/production": 435,
	"./icons/production.svg": 435,
	"./icons/profile": 436,
	"./icons/profile.svg": 436,
	"./icons/public_questions": 437,
	"./icons/public_questions.svg": 437,
	"./icons/reach": 438,
	"./icons/reach.svg": 438,
	"./icons/recommended": 439,
	"./icons/recommended.svg": 439,
	"./icons/settings": 440,
	"./icons/settings-dark": 441,
	"./icons/settings-dark.svg": 441,
	"./icons/settings.svg": 440,
	"./icons/single-user": 442,
	"./icons/single-user-plus": 443,
	"./icons/single-user-plus.svg": 443,
	"./icons/single-user.svg": 442,
	"./icons/sponsoring": 444,
	"./icons/sponsoring.svg": 444,
	"./icons/stats": 445,
	"./icons/stats.svg": 445,
	"./icons/stethoscope": 446,
	"./icons/stethoscope-dark": 447,
	"./icons/stethoscope-dark.svg": 447,
	"./icons/stethoscope.svg": 446,
	"./icons/three-users": 448,
	"./icons/three-users.svg": 448,
	"./icons/tools": 449,
	"./icons/tools.svg": 449,
	"./icons/top_picks": 450,
	"./icons/top_picks.svg": 450,
	"./icons/tour": 451,
	"./icons/tour.svg": 451,
	"./icons/two-users": 452,
	"./icons/two-users.svg": 452,
	"./icons/upicon": 453,
	"./icons/upicon.svg": 453,
	"./icons/upload": 454,
	"./icons/upload.svg": 454,
	"./icons/user-1": 455,
	"./icons/user-1.svg": 455,
	"./icons/user-white": 456,
	"./icons/user-white.svg": 456,
	"./icons/video": 457,
	"./icons/video.svg": 457,
	"./icons/vod": 458,
	"./icons/vod.svg": 458,
	"./icons/vods-count": 459,
	"./icons/vods-count.svg": 459,
	"./icons/warning": 460,
	"./icons/warning.svg": 460,
	"./icons/watchlist": 461,
	"./icons/watchlist.svg": 461,
	"./icons/youtube": 462,
	"./icons/youtube-color": 463,
	"./icons/youtube-color.svg": 463,
	"./icons/youtube-dark": 464,
	"./icons/youtube-dark.svg": 464,
	"./icons/youtube.svg": 462,
	"./index": 160,
	"./index.js": 160,
	"./insel-spital-logo": 465,
	"./insel-spital-logo.png": 465,
	"./institutions_logos": 466,
	"./institutions_logos.png": 466,
	"./live-bg": 467,
	"./live-bg.jpg": 467,
	"./lock": 468,
	"./lock.jpg": 468,
	"./logo": 161,
	"./logo-insel-2": 469,
	"./logo-insel-2.png": 469,
	"./logo.png": 161,
	"./logo_siwf_small": 470,
	"./logo_siwf_small.jpeg": 470,
	"./logos_siwf_big": 471,
	"./logos_siwf_big.jpg": 471,
	"./medupp-logo-brand": 472,
	"./medupp-logo-brand.png": 472,
	"./medupp-logo-dark": 473,
	"./medupp-logo-dark.png": 473,
	"./medupp-logo-light": 474,
	"./medupp-logo-light.png": 474,
	"./other_streaming_source": 475,
	"./other_streaming_source.png": 475,
	"./pdf": 170,
	"./pdf.png": 170,
	"./person_128x128": 476,
	"./person_128x128.jpg": 476,
	"./person_128x128_2": 477,
	"./person_128x128_2.jpg": 477,
	"./person_avatar_128x128": 478,
	"./person_avatar_128x128.png": 478,
	"./person_avatar_96x96": 479,
	"./person_avatar_96x96.png": 479,
	"./popup_back": 480,
	"./popup_back.png": 480,
	"./privacy": 172,
	"./privacy.jpg": 172,
	"./profile": 481,
	"./profile.png": 481,
	"./slider_down": 482,
	"./slider_down.png": 482,
	"./slider_up": 483,
	"./slider_up.png": 483,
	"./spratt": 484,
	"./spratt.jpg": 484,
	"./stats_demo": 485,
	"./stats_demo.png": 485,
	"./teams": 486,
	"./teams.png": 486,
	"./training_bg_image": 340,
	"./training_bg_image.jpg": 513,
	"./training_bg_image.png": 340,
	"./training_block_3": 487,
	"./training_block_3.png": 487,
	"./vod-bg": 488,
	"./vod-bg.jpg": 488,
	"./webex": 489,
	"./webex.png": 489,
	"./welcome-bg": 490,
	"./welcome-bg.jpg": 490,
	"./zebra-left": 491,
	"./zebra-left.png": 491,
	"./zebra-right": 492,
	"./zebra-right.png": 492,
	"./zoom": 493,
	"./zoom.png": 493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;